import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Grid,
  Input,
  Typography,
} from '@mui/material';
import { Formik, FormikHelpers, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { FormControl } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { showError } from '../../redux-store/actions/auth';
import MFCheckbox from '../../lib/formik/Checkbox';
import UseRadioGroup, { UseRadioGroupTransparent } from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import { useHistory, useParams, useRouteMatch } from 'react-router';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  ApplicationProps,
  InvestorEditRouteLinkObj,
  profileType,
  RiskProfile,
  RiskProfileMaster,
  RiskProfileMasterType,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import {
  IsRiskFieldTextfield,
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  checkIfApplicationIsNonIndividual,
  displayInputFieldWithLabel,
  fieldValidateForInvestor,
  getAge,
  getDisableStatusForjointHolder,
  getInvestorRouteLinks,
  getRiskAgeValue,
  getScore,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
} from '../../utils/utilityFunctions';
import { updateApplication } from '../../redux-store/actions/application';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APMIFlow,
  SHOW_SECTION_FILLED_BY_INVESTOR_CHECKBOX,
  USER_ROLES,
  YesNoMaster,
} from '../../utils/constant';
import { useSnackbar } from 'notistack';
import { riskProfileMasterData } from '../../redux-store/actions';
import { riskProfileDeclaration, sectionFilledByInvestor } from '../../utils/declaration';
import { fontSize } from '@mui/system';
import { ConfirmationDialog } from '../commonComponents';
import updateVisibility, { groupTypeCheck } from '../../utils/riskProfileUtils';
import _ from 'lodash';
import { refLoginCheck } from '../Investments/investor-application';
import { riskProfileScheme } from '../../utils/schema';
import { InvestorEditErrorObj } from '../../redux-store/reducers/investorEditSections';

export type updatedRiskProfile = RiskProfile &
  RiskProfileMasterType & {
    otherValue?: string;
    InvestmentGoal?: string[];
    scoreCal?: number;
  };
export const isQuestionTypeInvestmentPortfolio = (val: string): boolean =>
  val === 'investmentPortfolio';
export type Values = {
  isRiskProfileToBeFilledByInvestor: boolean;
  totalRiskProfileScore: number;
  riskprofiles: updatedRiskProfile[];
  saveType: string;
  isPastActions: string;
  pastActionDescription: string;
  riskProfileDeclaration: boolean;
};

export const RiskProfileObj: updatedRiskProfile = {
  question: '',
  answer: '',
  scoreText: '',
  otherValue: '',
  key: '',
  displayText: '',
  InvestmentGoal: [],
  scoreCal: 0,
};

const initialValues: Values = {
  riskProfileDeclaration: true,
  isRiskProfileToBeFilledByInvestor: APMIFlow ? true : false,
  totalRiskProfileScore: 0,
  riskprofiles: [],
  isPastActions: '',
  pastActionDescription: '',
  saveType: 'save and proceed',
};

export const setVisibilityFalse = (
  inputQId: string,
  q: Partial<updatedRiskProfile>,
  formValues: updatedRiskProfile[]
): void => {
  if (q.risk_id === inputQId) {
    q.isVisible = false;
    if (q.answer) {
      updateVisibility(q.answer, q, formValues);
    }
  } else if (q.questionType === 'radio' && q?.subQuestions?.length) {
    q.subQuestions?.forEach((_qns) => setVisibilityFalse(inputQId, _qns, formValues));
  }
};

export const setVisibility = (
  inputQId: string,
  q: Partial<updatedRiskProfile>,
  formValues: updatedRiskProfile[]
): void => {
  if (q.risk_id === inputQId) {
    q.isVisible = true;
    if (q.answer) {
      updateVisibility(q.answer, q, formValues);
    }
  } else if (q.questionType === 'radio' && q?.subQuestions?.length) {
    q.subQuestions?.forEach((_qns) => setVisibility(inputQId, _qns, formValues));
  }
};

function RiskDeclaration({
  data,
  values,
  setValues,
  setTotalScore,
  totalScore,
  disabled,
}: {
  data: updatedRiskProfile[];
  values: Values;
  setValues: FormikHelpers<Values>['setValues'];
  setTotalScore: any;
  totalScore: any;
  disabled: boolean;
}): JSX.Element {
  const [expanded, setExpanded] = React.useState<string | false>('');
  const { role = '', id: authId } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  useEffect(() => {
    setExpanded(disabled ? '' : expanded);
  }, [disabled]);

  const _handleSelection = async (
    ind: number,
    selectedOptionObj: any,
    InvestmentGoal: string[],
    scoreCal: string | number
  ) => {
    const index = InvestmentGoal?.indexOf(
      `${selectedOptionObj.key}_${selectedOptionObj.score}` as string
    );
    const investmentGoalSelect =
      index === -1
        ? [...InvestmentGoal, `${selectedOptionObj.key}_${selectedOptionObj.score}`]
        : InvestmentGoal?.filter(
            (goal: any) => goal != (`${selectedOptionObj.key}_${selectedOptionObj.score}` as string)
          );

    const total = investmentGoalSelect?.includes(
      `${selectedOptionObj.key}_${selectedOptionObj.score}`
    )
      ? Number(scoreCal) + Number(selectedOptionObj.score)
      : Number(scoreCal) - Number(selectedOptionObj.score);

    setValues({
      ...values,
      riskprofiles: values.riskprofiles.map((risk, index) => {
        if (index === ind) {
          return {
            ...risk,
            answer: investmentGoalSelect?.toString().replace(/,/g, '*'),
            scoreText: total.toFixed(1)?.toString() || '',
            InvestmentGoal: investmentGoalSelect,
            scoreCal: total,
          };
        }
        return risk;
      }),
    });
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Box sx={{ width: '100%' }}>
      {data?.map((dataValues: any, ind: any) => {
        return (
          <>
            {dataValues.isVisible && (
              <Accordion
                sx={{ boxShadow: 'none', mb: 3, '&::before': { display: 'none' } }}
                key={ind}
                expanded={expanded === `panel${ind}`}
                onChange={handleChange(`panel${ind}`)}
                disabled={disabled}>
                <AccordionSummary
                  sx={{
                    bgcolor: 'rgba(221, 234, 243, 0.2)',
                    borderRadius: '5px',
                    '&.Mui-expanded': { minHeight: 'unset' },
                    '& .MuiAccordionSummary-content': { '&.Mui-expanded': { my: 2 } },
                  }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${ind}d-content`}
                  id={`panel${ind}d-header`}>
                  <Typography
                    sx={{
                      color:
                        (!groupTypeCheck(dataValues.questionType) &&
                          values.riskprofiles[ind]?.answer !== '') ||
                        (groupTypeCheck(dataValues.questionType) &&
                          dataValues?.values?.some((_groupValue: any) => {
                            return dataValues[_groupValue.key as keyof updatedRiskProfile];
                          }))
                          ? '#57B6BA'
                          : '#131836',
                      fontSize: 14,
                      fontWeight: 600,
                    }}>
                    {`${ind + 1}. ${dataValues.displayText} ${
                      dataValues.required === 'true' && !disabled
                        ? APMIFlow
                          ? values.isRiskProfileToBeFilledByInvestor &&
                            fieldValidateForInvestor(referenceDetail.applicant_type, 1, false)
                            ? '*'
                            : ''
                          : '*'
                        : ''
                    }`}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ pb: 0 }}>
                  {['radio', 'multiSelectCheckBox'].includes(dataValues.questionType) && (
                    <>
                      {dataValues.isMultiselect === 'false' && (
                        <UseRadioGroupTransparent
                          name={`riskprofiles.${ind}.answer`}
                          items={dataValues.values.map((profile: any) => ({
                            label: profile.label,
                            value: profile.key,
                          }))}
                          disabled={getDisableStatusForjointHolder(
                            role,
                            referenceDetail.applicant_type,
                            amcuserAsInvestor
                          )}
                          onChange={(e) => {
                            let score;
                            setValues({
                              ...values,
                              riskprofiles: values.riskprofiles.map((risk, index) => {
                                if (index === ind) {
                                  score = risk.values?.filter((risk) => {
                                    return risk.key === e.target.value;
                                  })?.[0].score;
                                  setTotalScore(totalScore + Number(score));
                                  return {
                                    ...risk,
                                    answer: e.target.value,
                                    scoreText: score?.toString() || '',
                                  };
                                }
                                return risk;
                              }),
                            });
                            updateVisibility(e.target.value, dataValues, values.riskprofiles);
                          }}
                          sx={{
                            '& .MuiFormGroup-root': { flexDirection: 'column' },
                            '& .MuiFormControlLabel-label': { fontWeight: 400 },
                          }}
                        />
                      )}
                      {dataValues.isMultiselect === 'true' &&
                        dataValues.values.map((risk: any) => {
                          return (
                            <>
                              <FormControlLabel
                                key={dataValues.key}
                                value={dataValues.key}
                                sx={{
                                  width: '100%',
                                  position: 'relative',
                                  pb: 0,
                                  ml: 0.2,
                                  '.MuiFormLabel-root ': {
                                    color: 'primary.main',
                                    fontWeight: 600,
                                    mb: 0.5,
                                  },
                                  '.MuiFormControlLabel-root': {
                                    width: '100%',
                                    alignItems: 'flex-start',
                                    '.MuiTypography-root': {
                                      color: 'text.primary',
                                      fontWeight: 500,
                                      fontSize: 14,
                                      overflow: { xs: 'unset', md: 'hidden' },
                                      whiteSpace: { xs: 'unset', md: 'nowrap' },
                                      textOverflow: { xs: 'unset', md: 'ellipsis' },
                                      wordBreak: { xs: 'break-word', md: 'unset' },
                                    },
                                    '.MuiRadio-root,.MuiCheckbox-root ,.Mui-checked': {
                                      color: 'text.primary',
                                    },
                                    '.MuiRadio-root,.MuiCheckbox-root ': { p: 0, mr: 0.5 },
                                  },
                                  '.MuiAccordionDetails-root': {
                                    paddingTop: 0,
                                  },
                                  '.MuiAccordionSummary-content.Mui-expanded': {
                                    marginBottom: '10px',
                                  },
                                }}
                                onChange={() => {
                                  _handleSelection(
                                    ind,
                                    risk,
                                    dataValues.InvestmentGoal,
                                    dataValues.scoreCal
                                  );
                                }}
                                disabled={getDisableStatusForjointHolder(
                                  role,
                                  referenceDetail.applicant_type,
                                  amcuserAsInvestor
                                )}
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={dataValues.InvestmentGoal?.map((goal: any) =>
                                      goal.toString()
                                    ).includes(`${risk.key}_${risk.score}`)}
                                  />
                                }
                                label={risk.label}
                                title={risk.label}
                              />
                            </>
                          );
                        })}
                    </>
                  )}
                  {dataValues?.subQuestions?.map((_subQns: any, subInd: number) => {
                    return (
                      <>
                        {_subQns.isVisible && _subQns.questionType === 'sub_radio' && (
                          <UseRadioGroup
                            formLabel={`${_subQns.displayText} ${
                              _subQns.required === 'true' && !disabled ? '*' : ''
                            }`}
                            name={`riskprofiles.${ind}.subQuestions.${subInd}.answer`}
                            items={_subQns.values.map((profile: any) => ({
                              label: profile.label,
                              value: profile.key,
                            }))}
                            disabled={getDisableStatusForjointHolder(
                              role,
                              referenceDetail.applicant_type,
                              amcuserAsInvestor
                            )}
                          />
                        )}
                      </>
                    );
                  })}
                  {IsRiskFieldTextfield(dataValues.questionType) &&
                    !displayInputFieldWithLabel(dataValues.question) && (
                      <Grid xs={12} sm={6}>
                        <MFTextField
                          name={`riskprofiles.${ind}.answer`}
                          placeholder={`Enter here`}
                          disabled={getDisableStatusForjointHolder(
                            role,
                            referenceDetail.applicant_type,
                            amcuserAsInvestor
                          )}
                          sx={{
                            mb: 0,
                            '&.MuiInputBase-root': {
                              position: 'relative',
                              border: 0,
                              borderBottom: '1px solid #DDEAF3',
                              fontSize: 16,
                            },
                          }}
                        />{' '}
                        <Typography
                          sx={{
                            ml: 0.5,
                            mb: 4,
                            color: 'text.primary',
                          }}>
                          Year(s)
                        </Typography>
                      </Grid>
                    )}
                  {IsRiskFieldTextfield(dataValues.questionType) &&
                    displayInputFieldWithLabel(dataValues.question) && (
                      <>
                        <Grid
                          xs={12}
                          sm={12}
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            mt: 2,
                          }}>
                          <Input
                            value={values.riskprofiles[ind].answer}
                            size="small"
                            sx={{
                              width: { md: '45px', xs: '45px' },
                              ml: 2,
                              mb: 4,
                              '& ::placeholder': {
                                textTransform: 'none',
                                fontSize: '0.9rem',
                              },
                              'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button':
                                {
                                  WebkitAppearance: 'none',
                                  margin: 0,
                                },
                              'input[type=number]': { MozAppearance: 'textfield' },
                            }}
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            disabled={getDisableStatusForjointHolder(
                              role,
                              referenceDetail.applicant_type,
                              amcuserAsInvestor
                            )}
                            onChange={(event: any) => {
                              setValues({
                                ...values,
                                riskprofiles: values.riskprofiles.map((risk, index) => {
                                  if (index === ind) {
                                    return {
                                      ...risk,
                                      answer: event.target.value,
                                    };
                                  }
                                  return risk;
                                }),
                              });
                            }}
                            onFocus={(e) =>
                              e.target.addEventListener('wheel', (e) => e.preventDefault())
                            }
                          />
                          <Typography
                            sx={{
                              ml: 0.5,
                              mb: 4,
                              color: 'text.primary',
                            }}>
                            {isQuestionTypeInvestmentPortfolio(dataValues.question)
                              ? '%'
                              : 'Year(s)'}
                          </Typography>
                        </Grid>
                      </>
                    )}
                  {!IsRiskFieldTextfield(dataValues.questionType) &&
                    !groupTypeCheck(dataValues.questionType) &&
                    (values.riskprofiles[ind]?.answer === 'others' ||
                      (values.riskprofiles[ind].isMultiselect === 'true' &&
                        values.riskprofiles[ind]?.answer?.includes('others'))) && (
                      <Grid xs={12} sm={6}>
                        <MFTextField
                          name={`riskprofiles.${ind}.otherValue`}
                          placeholder={`Please specify`}
                          disabled={getDisableStatusForjointHolder(
                            role,
                            referenceDetail.applicant_type,
                            amcuserAsInvestor
                          )}
                          sx={{
                            mb: 0,
                            '&.MuiInputBase-root': {
                              position: 'relative',
                              border: 0,
                              borderBottom: '1px solid #DDEAF3',
                              fontSize: 16,
                            },
                          }}
                          onChange={(e) => {
                            const removeAstricOrUnderscore = e.target.value
                              ?.replace('*', '')
                              ?.replace('_', '');
                            setValues({
                              ...values,
                              riskprofiles: values.riskprofiles.map((risk, index) => {
                                if (index === ind) {
                                  return {
                                    ...risk,
                                    otherValue: removeAstricOrUnderscore,
                                  };
                                }
                                return risk;
                              }),
                            });
                          }}
                        />
                      </Grid>
                    )}
                  {groupTypeCheck(dataValues.questionType) &&
                    dataValues.values.map((_inputValue: any) => {
                      return (
                        <>
                          <Grid
                            xs={12}
                            sm={12}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              mt: 2,
                            }}>
                            <Input
                              value={
                                values.riskprofiles[ind][
                                  _inputValue.key as keyof updatedRiskProfile
                                ]
                              }
                              size="small"
                              sx={{
                                width: { md: '45px', xs: '45px' },
                                ml: 2,
                                mb: 4,
                                '& ::placeholder': {
                                  textTransform: 'none',
                                  fontSize: '0.9rem',
                                },
                                'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button':
                                  {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                  },
                                'input[type=number]': { MozAppearance: 'textfield' },
                              }}
                              type="number"
                              onKeyDown={(e) => {
                                allowOnlyNumbers(e);
                              }}
                              disabled={getDisableStatusForjointHolder(
                                role,
                                referenceDetail.applicant_type,
                                amcuserAsInvestor
                              )}
                              onChange={(event: any) => {
                                setValues({
                                  ...values,
                                  riskprofiles: values.riskprofiles.map((risk, index) => {
                                    if (index === ind) {
                                      return {
                                        ...risk,
                                        [_inputValue.key as string]: event.target.value,
                                      };
                                    }
                                    return risk;
                                  }),
                                });
                              }}
                              onFocus={(e) =>
                                e.target.addEventListener('wheel', (e) => e.preventDefault())
                              }
                            />
                            <Typography
                              sx={{
                                ml: 0.5,
                                mb: 4,
                                color: 'text.primary',
                              }}>
                              {_inputValue.label}
                            </Typography>
                          </Grid>
                        </>
                      );
                    })}
                </AccordionDetails>
              </Accordion>
            )}
          </>
        );
      })}
    </Box>
  );
}

export const profiletext = (total: number, profileData: profileType[]): any => {
  let text;
  profileData?.map((profile) => {
    const min = Math.min(profile.minScore, profile.maxScore),
      max = Math.max(profile.minScore, profile.maxScore);
    if (total >= min && total <= max) {
      text = (
        <>
          <Typography>
            You are{' '}
            <Typography component="strong" sx={{ fontSize: 16, fontWeight: 600, color: 'black' }}>
              {'  '}
              {profile.profile}.{' '}
            </Typography>
            {`${profile.Descriptions}. Your risk taking ability is ${profile.riskTakingAbility}`}
          </Typography>
        </>
      );
    }
  });
  return text;
};

export const handleIntialSelect = (riskprofiles: RiskProfile[], riskProfileQuestion: string) => {
  let selectedValue: string[] = [];
  const longTermArr = riskprofiles?.find((a) => a.question === riskProfileQuestion);
  selectedValue = longTermArr?.answer?.split('*') as unknown as string[];
  return selectedValue;
};

export const finalInitialQns = (dataWithAns: updatedRiskProfile[]) => {
  const visibilityUpdated = dataWithAns.map((q) => {
    if (['radio'].includes(q.questionType || '') && q.answer) {
      updateVisibility(q.answer, q, dataWithAns);
    }
    return q;
  });

  return visibilityUpdated;
};

export default function riskProfile(): JSX.Element {
  const [riskProfileData, setRiskProfileData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '', id: authId } = useSelector((store: RootStateType) => store.auth);

  const { enqueueSnackbar } = useSnackbar();
  const [riskProfileDataMaster, setRiskProfileDataMaster] = useState<RiskProfileMasterType[]>([]);
  const [profileData, setProfileData] = useState<profileType[]>([]);
  const [totalScore, setTotalScore] = useState(0);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();
  const [openPopup, setOpenPopup] = useState<{ riskProfileCheck: boolean } | null>(null);
  const { investorEditObj } = useSelector((store: RootStateType) => store.investorEditObj);
  const [investorRouteObj, setInvestorRouteObj] = useState<InvestorEditRouteLinkObj | null>(null);
  const [openPreviewConfirmationPopup, setOpenPreviewConfirmationPopup] = useState(false);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
        riskProfileDeclaration: applicationRiskProfileDeclaration,
      } = application || {};
      const {
        riskprofiles,
        isPastActions,
        pastActionDescription,
        isRiskProfileToBeFilledByInvestor,
        saveType,
        riskProfileDeclaration: valuesRiskProfileDeclaration,
      } = values;
      const amcuserAsInvestor = refLoginCheck(
        authId,
        application as unknown as ApplicationProps,
        referenceDetail
      );
      riskprofiles
        .filter((_qns) => groupTypeCheck(_qns.questionType || '') && _qns.required === 'true')
        .map((_groupCheck) => {
          if (
            (!isRiskProfileToBeFilledByInvestor ||
              (isRiskProfileToBeFilledByInvestor &&
                fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))) &&
            !_groupCheck.values?.some(
              (_groupValue) =>
                _groupCheck[_groupValue.key as keyof updatedRiskProfile] &&
                _groupCheck.required === 'true'
            )
          ) {
            throw 'Please fill all the required(*) fields';
          }
        });
      const checkAllQuestionsAnswered = riskprofiles
        ?.filter((_qns) => !groupTypeCheck(_qns.questionType || '') && _qns.required === 'true')
        ?.map((profile) => profile.answer !== '' && profile.required === 'true')
        ?.every((_profile) => _profile);

      if (
        (!isRiskProfileToBeFilledByInvestor ||
          (isRiskProfileToBeFilledByInvestor &&
            fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))) &&
        !checkAllQuestionsAnswered
      ) {
        throw 'Please fill all the required(*) fields';
      }
      riskprofiles?.map((risk) => {
        if (
          !isRiskProfileToBeFilledByInvestor ||
          (isRiskProfileToBeFilledByInvestor &&
            fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))
        ) {
          if (
            (risk.answer === 'others' ||
              (risk.isMultiselect === 'true' && risk.answer && risk.answer.includes('others'))) &&
            !risk.otherValue &&
            risk.required === 'true' &&
            !groupTypeCheck(risk?.questionType || '') &&
            !IsRiskFieldTextfield(risk?.questionType || '')
          ) {
            const questionForDisplay = riskProfileDataMaster
              ?.map((riskProfile) => {
                if (riskProfile.key === risk.question) {
                  return riskProfile.displayText;
                }
                return;
              })
              ?.filter((ele) => ele)
              ?.toString();
            throw 'Please specify others in ' + questionForDisplay;
          }
          risk?.subQuestions &&
            risk?.subQuestions.map((_subCheck: any) => {
              if (!_subCheck.answer && _subCheck.isVisible && _subCheck.required === 'true') {
                throw 'Please fill all the required(*) fields';
              }
            });
        }
      });
      if (
        !valuesRiskProfileDeclaration &&
        application &&
        checkIfApplicationIsNonIndividual(application)
      ) {
        throw 'Declaration is required';
      }
      const updatedRiskProfile = riskprofiles?.map((_riskProfile) => {
        const {
          otherValue,
          required,
          displayText,
          key,
          isMultiselect,
          totalPercentage,
          InvestmentGoal,
          scoreCal,
          isVisible,
          risk_id,
          subQuestions,
          ...rest
        } = _riskProfile;
        return {
          ...rest,
          answer:
            otherValue && rest.answer === 'others'
              ? otherValue
              : isMultiselect === 'true' && otherValue && rest.answer?.includes('others')
              ? rest.answer?.replace('others', otherValue)
              : rest.answer,
          subriskprofiles:
            subQuestions && subQuestions.length > 0
              ? subQuestions
                  .map((_subRisk: any) => {
                    const {
                      risk_id,
                      questionType,
                      key,
                      required,
                      totalPercentage,
                      isMultiselect,
                      displayText,
                      values,
                      isVisible,
                      ..._rest
                    } = _subRisk;
                    return {
                      ..._rest,
                      answer: isVisible ? _rest.answer : '',
                      ...(_rest.id && { isActive: isVisible }),
                    };
                  })
                  .filter(
                    (_sub_riskprofile: any) => _sub_riskprofile?.id || _sub_riskprofile.answer
                  )
              : [],
          ...(rest?.id
            ? {
                isActive:
                  required === 'false' &&
                  !rest.answer &&
                  !rest.values?.some(
                    (_groupValue) =>
                      (rest as updatedRiskProfile)[_groupValue.key as keyof updatedRiskProfile]
                  )
                    ? false
                    : rest.isActive,
              }
            : {}),
        };
      });
      const updatedPayload = {
        ...application,
        riskProfileDeclaration:
          application && checkIfApplicationIsNonIndividual(application)
            ? valuesRiskProfileDeclaration
            : applicationRiskProfileDeclaration,
        totalRiskProfileScore:
          !APMIFlow &&
          isRiskProfileToBeFilledByInvestor &&
          !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false)
            ? 0
            : Number(manageTotal(values).toFixed(1)),
        isRiskProfileToBeFilledByInvestor,
        isPastActions,
        pastActionDescription:
          YesNoMaster[isPastActions] === YesNoMaster.yes ? pastActionDescription : '',
        riskprofiles:
          !APMIFlow &&
          isRiskProfileToBeFilledByInvestor &&
          !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false)
            ? updatedRiskProfile && updatedRiskProfile?.length > 0
              ? (updatedRiskProfile
                  ?.map((_profile) => {
                    const { questionType, ...rest } = _profile;
                    if (_profile.id) {
                      return {
                        ...rest,
                        isActive: false,
                        subriskprofiles: rest.subriskprofiles?.map((_sub_qns) => ({
                          ..._sub_qns,
                          isActive: false,
                        })),
                      };
                    }
                    return;
                  })
                  .filter((ele) => ele) as updatedRiskProfile[])
              : updatedRiskProfile
                  ?.filter((profile: updatedRiskProfile) => {
                    if (groupTypeCheck(profile.questionType || '')) {
                      return (
                        profile.answer ||
                        profile.id ||
                        profile.values?.some(
                          (_groupValue) => profile[_groupValue.key as keyof updatedRiskProfile]
                        )
                      );
                    } else {
                      return profile.answer || profile.id;
                    }
                  })
                  .map((_profile) => {
                    const { questionType, values, ...rest } = _profile;
                    return rest;
                  })
            : updatedRiskProfile
                ?.filter((profile: updatedRiskProfile) => {
                  if (groupTypeCheck(profile.questionType || '')) {
                    return (
                      profile.answer ||
                      profile.id ||
                      profile.values?.some(
                        (_groupValue) => profile[_groupValue.key as keyof updatedRiskProfile]
                      )
                    );
                  } else {
                    return profile.answer || profile.id;
                  }
                })
                .map((_profile) => {
                  const { questionType, values, ...rest } = _profile;
                  return rest;
                }),
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          riskprofiles: application?.riskprofiles?.sort(
            (riskprofile1, riskprofile2) => Number(riskprofile1.id) - Number(riskprofile2.id)
          ),
        },
        {
          ...updatedPayload,
          riskprofiles: updatedPayload?.riskprofiles?.sort(
            (riskprofile1, riskprofile2) => Number(riskprofile1.id) - Number(riskprofile2.id)
          ),
          currentStep: !!currentStep && currentStep > 7 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : referenceDetail.esignReferenceId;
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role) &&
                !amcuserAsInvestor
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: investorRouteObj ? currentStep : 8,
              ...(APMIFlow && {
                editedByPrimaryApplicant: investorRouteObj
                  ? true
                  : application?.editedByPrimaryApplicant,
              }),
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        setLoading(false);
        !isSaveLater
          ? investorRouteObj
            ? investorRouteObj.saveAndProceedSectionLink
              ? history.push(investorRouteObj.saveAndProceedSectionLink, {
                  id,
                  applicant1ReferenceId: referenceIdForSaveProceedRoute,
                })
              : setOpenPreviewConfirmationPopup(true)
            : history.push('strategy-details', {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
          : referenceIdForInvestorPhotoCapture && !investorRouteObj
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : investorRouteObj
          ? investorRouteObj.backSectionLink
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
            : history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              )
          : history.push(
              saveForLater(role, id, referenceDetail.esignReferenceId, amcuserAsInvestor)
            );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? investorRouteObj
            ? investorRouteObj.saveAndProceedSectionLink
              ? history.push(investorRouteObj.saveAndProceedSectionLink, {
                  id,
                  applicant1ReferenceId: referenceIdForSaveProceedRoute,
                })
              : setOpenPreviewConfirmationPopup(true)
            : history.push('strategy-details', {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
          : referenceIdForInvestorPhotoCapture && !investorRouteObj
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : investorRouteObj
          ? investorRouteObj.backSectionLink
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
            : history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              )
          : history.push(
              saveForLater(role, id, referenceDetail.esignReferenceId, amcuserAsInvestor)
            );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        const response = (await dispatch(riskProfileMasterData())) as unknown as RiskProfileMaster;
        if (!isComponentAlive) {
          return;
        }
        setRiskProfileDataMaster(response.riskProfile);
        setProfileData(response.profile);
        const {
          riskprofiles = [],
          isPastActions = '',
          pastActionDescription = '',
          isRiskProfileToBeFilledByInvestor = true,
          riskProfileDeclaration = true,
        } = application || {};
        setRiskProfileData({
          ...riskProfileData,
          riskProfileDeclaration: riskProfileDeclaration === null ? true : riskProfileDeclaration,
          isRiskProfileToBeFilledByInvestor:
            isRiskProfileToBeFilledByInvestor || initialValues.isRiskProfileToBeFilledByInvestor,
          isPastActions,
          pastActionDescription:
            YesNoMaster[isPastActions || ''] === YesNoMaster.yes ? pastActionDescription : '',
          riskprofiles: response.riskProfile
            ?.map((mdmsProfile) => {
              const existingRiskProfiles = riskprofiles?.filter(
                (risk_profiles) => risk_profiles.question === mdmsProfile.key
              );

              const riskProfileDataWithAns =
                existingRiskProfiles.length > 0 &&
                existingRiskProfiles?.map((existingProfiles) => {
                  if (
                    existingProfiles.question === mdmsProfile.key &&
                    mdmsProfile.isMultiselect === 'true'
                  ) {
                    const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key || '');
                    const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                    let getOtherValue = '';
                    const updateOptions = getInvestment.map((ans) => {
                      if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                        getOtherValue = ans.split('_')[0];
                        return `others_${ans.split('_')[1]}`;
                      }
                      return ans;
                    });
                    return {
                      ...existingProfiles,
                      ...mdmsProfile,
                      values: mdmsProfile.values?.map((value) => {
                        const scoreUpdate = updateOptions
                          .find((investment) => investment?.split('_')[0] === value.key)
                          ?.split('_')[1];

                        return {
                          ...value,
                          score: scoreUpdate ? Number(scoreUpdate) : value.score,
                        };
                      }),
                      InvestmentGoal: updateOptions || [],
                      scoreCal: Number(existingProfiles.scoreText) || 0,
                      otherValue: getOtherValue,
                      answer: getOtherValue
                        ? updateOptions?.toString()?.replace(/,/g, '*')
                        : existingProfiles.answer,
                    };
                  } else {
                    const checkAnswer =
                      existingProfiles.question === mdmsProfile.key &&
                      mdmsProfile.isMultiselect === 'false' &&
                      mdmsProfile.values
                        ?.map((value) => value.key)
                        .includes(existingProfiles.answer || '');
                    return {
                      ...existingProfiles,
                      ...mdmsProfile,
                      values: mdmsProfile.values?.map((value) => {
                        if (existingProfiles.answer === value.key) {
                          return {
                            ...value,
                            score: Number(existingProfiles.scoreText),
                          };
                        }
                        return value;
                      }),
                      otherValue:
                        checkAnswer || IsRiskFieldTextfield(mdmsProfile?.questionType || '')
                          ? ''
                          : existingProfiles.answer,
                      answer:
                        checkAnswer || IsRiskFieldTextfield(mdmsProfile?.questionType || '')
                          ? existingProfiles.answer
                          : groupTypeCheck(mdmsProfile?.questionType || '')
                          ? ''
                          : 'others',
                      ...(mdmsProfile?.subQuestions
                        ? {
                            subQuestions: mdmsProfile.subQuestions.map((_subQnsUpdate) => {
                              const subQuestionAns = existingProfiles?.subriskprofiles?.find(
                                (_subQns) => _subQns.question === _subQnsUpdate.key
                              );
                              return {
                                ...subQuestionAns,
                                ..._subQnsUpdate,
                                question: _subQnsUpdate.key,
                                answer:
                                  subQuestionAns &&
                                  _subQnsUpdate.values
                                    ?.map((value) => value.key)
                                    .includes(subQuestionAns?.answer || '')
                                    ? subQuestionAns.answer
                                    : '',
                              };
                            }),
                          }
                        : {}),
                    };
                  }
                });

              return existingRiskProfiles.length && riskProfileDataWithAns
                ? finalInitialQns(riskProfileDataWithAns)
                : [
                    {
                      ...RiskProfileObj,
                      question: mdmsProfile.key,
                      answer:
                        APMIFlow ||
                        isRiskProfileToBeFilledByInvestor === null ||
                        (isRiskProfileToBeFilledByInvestor &&
                          fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))
                          ? mdmsProfile.values?.length === 1
                            ? mdmsProfile.values[0]?.key
                            : mdmsProfile.key === 'age'
                            ? getRiskAgeValue(
                                getAge(
                                  application?.applicants?.find(
                                    (_applicant) => _applicant.applicant_type === '1'
                                  )?.dateOfBirth
                                )
                              )
                            : ''
                          : '',
                      scoreText:
                        APMIFlow ||
                        isRiskProfileToBeFilledByInvestor === null ||
                        (isRiskProfileToBeFilledByInvestor &&
                          fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))
                          ? mdmsProfile.values?.length === 1
                            ? mdmsProfile?.values[0]?.score?.toString()
                            : mdmsProfile.key === 'age'
                            ? getScore(
                                getRiskAgeValue(
                                  getAge(
                                    application?.applicants?.find(
                                      (_applicant) => _applicant.applicant_type === '1'
                                    )?.dateOfBirth
                                  )
                                )
                              )
                            : ''
                          : '',
                      ...mdmsProfile,
                      ...(mdmsProfile?.subQuestions
                        ? {
                            subQuestions: mdmsProfile.subQuestions.map((_subQnsUpdate) => {
                              return {
                                ..._subQnsUpdate,
                                question: _subQnsUpdate.key,
                                answer:
                                  APMIFlow ||
                                  isRiskProfileToBeFilledByInvestor === null ||
                                  (isRiskProfileToBeFilledByInvestor &&
                                    fieldValidateForInvestor(
                                      referenceDetail.applicant_type,
                                      1,
                                      false
                                    ))
                                    ? _subQnsUpdate.values?.length === 1
                                      ? _subQnsUpdate.values[0]?.key
                                      : ''
                                    : '',
                              };
                            }),
                          }
                        : {}),
                    },
                  ];
            })
            .flat(),
        });
        const routeLinkObj =
          (investorEditObj && investorEditObj?.length > 0) ||
          (APMIFlow && referenceDetail?.applicant_type === '1')
            ? getInvestorRouteLinks(
                investorEditObj as InvestorEditErrorObj[],
                history?.location?.pathname?.split('/')?.pop() || '',
                referenceDetail
              )
            : null;
        setInvestorRouteObj(routeLinkObj);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, [application]);

  const manageTotal = (values: Values) => {
    const total = values.riskprofiles
      .map((risk) => {
        return Number(risk.scoreText);
      })
      .reduce(function (acc, val) {
        return acc + val;
      }, 0);

    return total;
  };

  return (
    <Formik
      initialValues={riskProfileData}
      validationSchema={riskProfileScheme}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          //columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          {SHOW_SECTION_FILLED_BY_INVESTOR_CHECKBOX &&
            !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false) &&
            application &&
            !checkIfApplicationIsNonIndividual(application) && (
              <Grid xs={12} sx={{ mb: 2 }}>
                <MFCheckbox
                  name="isRiskProfileToBeFilledByInvestor"
                  label={sectionFilledByInvestor}
                  sx={{ display: 'flex' }}
                  onChange={({ target: { checked } }) => {
                    const updatedRiskProfile = riskProfileDataMaster?.map((mdmsProfile) => {
                      const riskObj = values.riskprofiles?.find(
                        (_profile) => _profile.key === mdmsProfile.key
                      );
                      const groupQnsObj = groupTypeCheck(riskObj?.questionType || '')
                        ? riskObj?.values
                            ?.map((_obj) => {
                              if (riskObj[_obj.key as keyof updatedRiskProfile]) {
                                return { [_obj.key as string]: '' };
                              }
                            })
                            .filter((ele) => ele)
                        : [];
                      return {
                        ...RiskProfileObj,
                        question: mdmsProfile.key,
                        ...riskObj,
                        answer:
                          mdmsProfile.values?.length === 1
                            ? mdmsProfile.values[0]?.key
                            : mdmsProfile.key === 'age'
                            ? getRiskAgeValue(
                                getAge(
                                  application?.applicants?.find(
                                    (_applicant) => _applicant.applicant_type === '1'
                                  )?.dateOfBirth
                                )
                              )
                            : '',
                        scoreText:
                          mdmsProfile.values?.length === 1
                            ? mdmsProfile?.values[0]?.score?.toString()
                            : mdmsProfile.key === 'age'
                            ? getScore(
                                getRiskAgeValue(
                                  getAge(
                                    application?.applicants?.find(
                                      (_applicant) => _applicant.applicant_type === '1'
                                    )?.dateOfBirth
                                  )
                                )
                              )
                            : '',
                        ...groupQnsObj?.reduce((result, currentObject) => {
                          return { ...result, ...currentObject };
                        }, {}),
                        ...mdmsProfile,
                        ...(mdmsProfile?.subQuestions
                          ? {
                              subQuestions: mdmsProfile.subQuestions.map((_subQnsUpdate) => {
                                return {
                                  ..._subQnsUpdate,
                                  question: _subQnsUpdate.key,
                                  answer:
                                    _subQnsUpdate.values?.length === 1
                                      ? _subQnsUpdate.values[0]?.key
                                      : '',
                                };
                              }),
                            }
                          : {}),
                      };
                    });
                    !checked &&
                      setValues({
                        ...values,
                        isRiskProfileToBeFilledByInvestor: checked,
                        riskprofiles: [...updatedRiskProfile],
                      });
                    checked && setOpenPopup({ riskProfileCheck: checked });
                  }}
                  checked={values.isRiskProfileToBeFilledByInvestor}
                  disabled={APMIFlow ? true : false}
                />
              </Grid>
            )}
          <RiskDeclaration
            data={values.riskprofiles}
            values={values}
            setValues={setValues}
            setTotalScore={setTotalScore}
            totalScore={totalScore}
            disabled={
              APMIFlow
                ? false
                : values.isRiskProfileToBeFilledByInvestor &&
                  !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false)
            }
          />
          <Grid item xs={12} sm={12} sx={{ mb: { xs: 2.8, md: 1 } }}>
            <Typography sx={{ fontSize: 25, fontWeight: 500, color: '#131836', mb: 4 }}>
              Past Actions *
            </Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 500, mb: 1 }}>
              Details of any action/proceedings initiated/pending/taken by SEBI/Stock exchange/any
              other authority against the applicant/constituent or its Partners/promoters/whole time
              directors/ authorised persons in charge of dealing in securities during the last 3
              years
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ mb: { xs: 2.8, md: 1 } }}>
            <UseRadioGroup
              formLabel=""
              name="isPastActions"
              items={Object.keys(YesNoMaster).map((item) => ({
                label: YesNoMaster[item],
                value: item,
              }))}
            />
          </Grid>
          {YesNoMaster[values?.isPastActions || ''] === YesNoMaster.yes && (
            <Grid item xs={12}>
              <MFTextField
                name="pastActionDescription"
                multiline
                rows={3}
                label="Description *"
                placeholder="Enter Description"
              />
            </Grid>
          )}

          {/* <Typography
            sx={{
              color: 'black',
              fontWeight: 600,
              fontSize: 14,
              mt: 2,
            }}>{`Your total Score is ${manageTotal(values).toFixed(1)}
          `}</Typography>
          <Typography sx={{ mt: 1 }}>
            {profiletext(Number(manageTotal(values).toFixed(1)), profileData)}
          </Typography>
      */}
          {application && checkIfApplicationIsNonIndividual(application) && (
            <Grid item xs={12}>
              <MFCheckbox
                name={`riskProfileDeclaration`}
                label={riskProfileDeclaration}
                sx={{ display: 'flex', alignItems: 'flex-start' }}
              />
            </Grid>
          )}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
            saveForLaterButtonText={
              investorRouteObj
                ? investorRouteObj.backSectionLink
                  ? `Save and Back To ${investorRouteObj.backSectionName}`
                  : 'Save For Later'
                : 'Save For Later'
            }
            saveButtonText={
              investorRouteObj
                ? investorRouteObj.saveAndProceedSectionLink
                  ? 'Save and Proceed'
                  : 'Save Application'
                : 'Save and Proceed'
            }
            showEndIcon={
              investorRouteObj ? (investorRouteObj.saveAndProceedSectionLink ? true : false) : true
            }
            showSaveForLater={
              investorRouteObj ? (investorRouteObj.backSectionLink ? true : false) : true
            }
          />
          <ConfirmationDialog
            message={`Are you sure you do not wish to fill this step ?`}
            open={openPopup !== null}
            setOpen={() => {
              setOpenPopup(null);
            }}
            onSave={() => {
              setValues({
                ...values,
                isRiskProfileToBeFilledByInvestor: openPopup?.riskProfileCheck as boolean,
                riskprofiles: values.riskprofiles?.map((_profile) => {
                  const riskObj = values.riskprofiles?.find(
                    (__riskProfile) => __riskProfile.key === _profile.key
                  );
                  const groupQnsObj = groupTypeCheck(riskObj?.questionType || '')
                    ? riskObj?.values
                        ?.map((_obj) => {
                          if (riskObj[_obj.key as keyof updatedRiskProfile]) {
                            return { [_obj.key as string]: '' };
                          }
                        })
                        .filter((ele) => ele)
                    : [];
                  return {
                    ..._profile,
                    answer: '',
                    scoreText: '',
                    InvestmentGoal: [],
                    scoreCal: 0,
                    ...groupQnsObj?.reduce((result, currentObject) => {
                      return { ...result, ...currentObject };
                    }, {}),
                  };
                }),
              });
              setOpenPopup(null);
            }}
            onCancel={() => {
              setOpenPopup(null);
            }}
          />
          <ConfirmationDialog
            message={`Application Saved successfully and no further edits provided, Are you sure you want to go back to preview?`}
            open={openPreviewConfirmationPopup}
            setOpen={() => {
              setOpenPreviewConfirmationPopup(false);
            }}
            onSave={() => {
              setOpenPreviewConfirmationPopup(false);
              history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              );
            }}
            onCancel={() => {
              setOpenPreviewConfirmationPopup(false);
            }}
          />
        </Grid>
      )}
    </Formik>
  );
}
